/**
 * @author HungNS
 */
import * as TYPE from "./type";
import FactoryService from '@/services/FactoryService.js'

const newsService = FactoryService.getService('news')
const moduleNews = {
    namespaced: true,
    state: () => ({
        resultAgreeNews: null,
        listAgreeNewsInfo: null,
        listForceNewsInfo: [],

        hideTopMenu: true,
        forceNewsFlg: false,
        agreeNewsInfoFlg: false,
        reAgreementNewsFlg: false,
        reAgreeMessageId: "",

        hasAgreementBoBlock: false,
        hasAgreementFxBlock: false,
        isNewsInit: false,
        needRegisterPasskey: false,
        routerName: "index"
    }),
    mutations: {
        [TYPE.FORCE_SET_AGREE_FLG](state, payload){
            state.hideTopMenu = payload;
        },

        [TYPE.SET_RE_AGREEMENT_FLG](state, payload){
            state.reAgreementNewsFlg = payload;
        },

        [TYPE.SET_FORCE_NEWS_FLG](state, payload){
            state.forceNewsFlg = payload;
        },

        [TYPE.SET_AGREE_MENT_FLG](state, payload){
            state.agreeNewsInfoFlg = payload;
        },

        mutationNeedRegisterPasskey(state, value) {
            state.needRegisterPasskey = value
        },

        mutationHideTopMenu(state, value) {
            state.hideTopMenu = value
        },

        [TYPE.SET_AGREE_FLG](state, {data}) {
            if (data) {
                state.needRegisterPasskey = data.needRegisterPasskey;
                    state.resultAgreeNews = data;
                    if (data.listAmsCustomerNewsView && data.listAmsCustomerNewsView.length > 0) {
                        let listAmsCustomerNewsView = data.listAmsCustomerNewsView;
                        for (let i = 0; i < listAmsCustomerNewsView.length; i++) {
                            state.reAgreeMessageId += (listAmsCustomerNewsView[i].messageId + ",");
                            let serviceType = listAmsCustomerNewsView[i].serviceType;
                            if ((serviceType == 4 || serviceType == 0) && data.boStatus != 1) {
                                state.hasAgreementBoBlock = true;
                            }
                            if (serviceType == 21 || serviceType == 0) {
                                state.hasAgreementFxBlock = true;
                            }
                        }
                        state.reAgreementNewsFlg = true;
                    }
                    if (data.listAgreeNewsInfo && data.listAgreeNewsInfo.length > 0) {
                        let listAgreeNewsInfo = data.listAgreeNewsInfo;
                        state.listAgreeNewsInfo = listAgreeNewsInfo;
                        state.agreeNewsInfoFlg = true;
                    }
                    if (data.listForceNewsInfo && data.listForceNewsInfo.length > 0) {
                        state.listForceNewsInfo = [...data.listForceNewsInfo];
                        state.forceNewsFlg = true;
                    }
            }
            if (state.needRegisterPasskey){
                state.hideTopMenu = false;
            } else if (state.reAgreementNewsFlg){
                state.hideTopMenu = true;
            } else state.hideTopMenu = state.forceNewsFlg;

            state.isNewsInit = true;
        },
        // using this function for updating fields in state
        updateFields(state, payload) {
            Object.assign(state, payload);
        }
    },
    actions: {
        async [TYPE.GET_AGREE_FLG]({commit, rootState}) {
            const headerInfo = rootState?.header?.headerInfo ?? null;
            const data = await newsService.getAgreeNews();
            if (headerInfo) {
                commit(TYPE.SET_AGREE_FLG, {
                    data: data,
                    headerInfo: headerInfo
                });
            } else {
                console.error("headerInfo is null")
            }
        },
        async [TYPE.INIT_AGREE_NEWS]({dispatch}) {
            await sleep(-1);
            await dispatch(TYPE.GET_AGREE_FLG);
        },

        [TYPE.SET_AGREE_MENT_FLG]({commit}, payload) {
            commit(TYPE.SET_AGREE_MENT_FLG, payload);
        },

        [TYPE.SET_RE_AGREEMENT_FLG]({commit}, payload) {
            commit(TYPE.SET_RE_AGREEMENT_FLG, payload);
        },

        [TYPE.SET_FORCE_NEWS_FLG]({commit}, payload) {
            commit(TYPE.SET_FORCE_NEWS_FLG, payload);
        },

        [TYPE.FORCE_SET_AGREE_FLG]({commit}, payload) {
            commit(TYPE.FORCE_SET_AGREE_FLG, payload);
        },

        actionNeedRegisterPasskey({commit}, value) {
            commit('mutationNeedRegisterPasskey', value)
        },

        actionHideTopMenu({commit}, value) {
            commit('mutationHideTopMenu', value)
        }
    },
    getters: {},
};

const sleep = (ms) => {
    if (ms > 0) return new Promise(resolve => setTimeout(resolve, ms));
};

export default moduleNews;
